import initialState from "../initialState";
import {
    preloaderDisplay,
    error,
    currentWeatherLoaded,
    forecastWeatherLoaded
    } from './../actions';
import store from './../index';

export default function getWeather(settings) {
    let  { defaultSettings } = initialState;
    settings = { ...defaultSettings, ...settings };
    return dispatch => {
        function fetchRequest(url, callback) {
            return (
                fetch(url)
                    .then(response => response.json())
                    .then(data => dispatch(callback(data)))
                    .catch(err => {
                        console.warn('Не удалось загрузить данные', err);
                        dispatch(error(true));
                    })
            )
        }
        let loadCurrentWeather =  fetchRequest(`${settings.host}weather?APPID=${settings.appId}&id=${settings.cityId}&units=${settings.units}&lang=${settings.lang}`,
            currentWeatherLoaded);

        let loadForecastWeather = fetchRequest(`${settings.host}forecast?APPID=${settings.appId}&id=${settings.cityId}&units=${settings.units}&lang=${settings.lang}`,
            forecastWeatherLoaded);

        Promise.all([
            loadCurrentWeather,
            loadForecastWeather
        ]).then(() => {
            if (store.getState().weatherIcon.imgLoaded) {
                dispatch(preloaderDisplay(false));
            }
        })
    };
}